import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormManager, FormRow, Grid, PageTitle, useCacheQuery, useCloneEntity } from 'gossamer-front-end';
import { InstitutionGroup, InstitutionGroupTimeLabel, InstitutionGroupTimeLabelRow } from 'cb-model';
import { getFilter, getListRowLink } from 'gossamer-unified';

export const InstitutionGroupTimeLabelGrid = (): React.JSX.Element => {
  const params = useParams();
  const navigate = useNavigate();
  const query = useCacheQuery(InstitutionGroupTimeLabel, {
    where: { and: [getFilter('institution_group_id', 'eq', params.key)] },
    order: [['start_date', 'ASC']],
  });
  const handleExit = () => navigate(getListRowLink(InstitutionGroup.listRowLink, params.key));
  const LocalInstitutionGroupTimeLabel = useCloneEntity(InstitutionGroupTimeLabel, (local) => {
    local.fields.institution_group_id.listColumn = false;
  });
  return (
    <>
      <PageTitle verb="Update" entity={InstitutionGroupTimeLabel} />
      <FormManager
        compoundUrl="/main/~/institution-group-time-label-grid"
        handleCancel={handleExit}
        handleSuccess={handleExit}
        initialization={{
          main: {
            type: 'update-multi',
            entity: LocalInstitutionGroupTimeLabel,
            query,
          },
        }}
      >
        <Grid
          valuesKey="main"
          entity={LocalInstitutionGroupTimeLabel}
          onAddRow={(data: FormRow<InstitutionGroupTimeLabelRow>) => {
            data.institution_group_id = parseInt(params.key);
          }}
        />
      </FormManager>
    </>
  );
};
